import { Component, OnInit } from '@angular/core';
import { ValmetDnaService } from '../valmet-dna.service';
@Component({
  selector: 'qm-neve-base',
  templateUrl: './neve-base.component.html',
  styleUrls: ['./neve-base.component.scss']
})
export class NeveBaseComponent implements OnInit {
  constructor(private valmetDna: ValmetDnaService) {
  }

  ngOnInit(): void {
  }
}
